export const OPENING_TICKET_PURPOSE_REF_ICONS = ['1-Admin',
    '1-Animaux',
    '1-Bricolage',
    '1-Junior',
    '1-Pressing',
    '1-Seniors',
    'Achatappartement',
    'Achatmaison',
    'Aide course',
    'Aide devoir',
    'Aide hygiene',
    'Aide repas',
    'aircon',
    'alarm',
    'Assurance habitation',
    'Autre animal',
    'Babysitting',
    'barrier',
    'boiler_1',
    'boiler',
    'brokenglass',
    'bucket',
    'burglar',
    'careTaker',
    'Chat',
    'Chemise',
    'Chien',
    'Colocation avec GLI',
    'Colocation sans GLI',
    'Coloocation etudiante avec GLI',
    'Coloocation etudiante sans GLI',
    'Compteur electric',
    'Demenagement',
    'door',
    'electrecity',
    'electricité',
    'elevator',
    'explosion',
    'extinctor',
    'fail',
    'fence',
    'firefighters',
    'flood',
    'gas',
    'gasvent',
    'Gaz',
    'heater',
    'hotwater',
    'Installation electric',
    'intercom',
    'internet',
    'intrusionalarm',
    'Jardinage',
    'keys',
    'key',
    'lamp',
    'Lessive',
    'linge au poids',
    'litter',
    'Locationappartement',
    'Location etudiante avec GLI',
    'Location etudiante sans GLI',
    'Location hors etudiante avec GLI',
    'Location hors etudiante sans GLI',
    'Locationmaison',
    'Location voiture',
    'manager',
    'manogas',
    'marker',
    'masonry',
    'MenagePrintemps',
    'Menage',
    'Menage-travaux',
    'message',
    'monitoring',
    'openlock',
    'other',
    'Outiltravaux',
    'Pantalon',
    'parking',
    'Peinture',
    'Petitstravaux',
    'pipe',
    'police',
    'pressure',
    'pump',
    'questionmark',
    'Raccordement',
    'relocate',
    'Repassage',
    'rollerblind',
    'roof',
    'smokevent',
    'Surface',
    'swimmingpool',
    'tablette',
    'tap',
    'terminal',
    'tv',
    'vandalism',
    'vent',
    'Veste',
    'Vitre',
    'voir_les_demandes',
    'warning',
    'waterdrop',
    'watertap',
    'window',
    'wrench',
].map(t => t.replace(/ /g, '_'))

export class OpeningTicketPurposeRef {
}

OpeningTicketPurposeRef.expendChildrenCategories = (reference, category) => {
    if (category) {
        const childrenCategories = reference.categories.reduce((result, childCategory) => {
            if (childCategory.parent && childCategory.parent.uid == category.uid) {
                result.push(...OpeningTicketPurposeRef.expendChildrenCategories(reference, childCategory))
            }
            return result
        }, [])

        return [category, ...childrenCategories]
    }
    return []
}

OpeningTicketPurposeRef.expendParentCategories = (reference, category) => {
    if (category) {
        const parentCategory = category.parent && reference.categories.find((c) => c.uid == category.parent.uid)
        return [...OpeningTicketPurposeRef.expendParentCategories(reference, parentCategory), category]
    }
    return []
}

OpeningTicketPurposeRef.getLeafCategory = (categoryPath) => {
    var leaf

    for (var i = 0 ; i < categoryPath.length ; i++) {
        const parentCategory = categoryPath[i - 1]
        const category = categoryPath[i]

        if ((category.parent && category.parent.uid) != (parentCategory && parentCategory.uid)) break
        leaf = category
    }
    return leaf
}

OpeningTicketPurposeRef.truncCategoryPath = (categoryPath, rootCategory) => {
    if (!rootCategory && !(categoryPath[0] && categoryPath[0].parent)) {
        return categoryPath
    }

    if (!rootCategory && (categoryPath[0] && categoryPath[0].parent)) {
        return []
    }

    const index = categoryPath.findIndex((c) => c.uid == rootCategory.uid)
    if (index < 0) {
        return []
    } else {
        return categoryPath.slice(index + 1)
    }
}

OpeningTicketPurposeRef.isDefaultOpeningTicketPurpose = (reference, openingTicketPurpose) => {
    return reference.default.openingTicketPurpose.uid == openingTicketPurpose.uid
}

export class CreateOpeningTicketPurposeAction {
}

CreateOpeningTicketPurposeAction.schema = {
    type: 'object',
    properties: {
        label: {type: 'string'},
        extId: {type: ['string', 'null']},
        categoryUids: {
            type: 'array',
            minItems: 1,
            items: {type: 'object'}
        },
        tagUids: {
            type: 'array',
            minItems: 1,
            items: {type: 'object'}
        }
    },
    required: ['label', 'categoryUids', 'tagUids']
}

export class UpdateOpeningTicketPurposeAction {
}

UpdateOpeningTicketPurposeAction.schema = {
    type: 'object',
    properties: {
        label: {type: 'string'},
        extId: {type: ['string', 'null']}
    },
    required: ['label']
}

export class CreateUpdateTagAction {
}

CreateUpdateTagAction.schema = {
    type: 'object',
    properties: {
        label: {type: 'string'},
        iconId: {type: 'string'},
        action: {type: 'string'}
    },
    required: ['label', 'iconId', 'action']
}

export class CreateUpdateCategoryAction {
}

CreateUpdateCategoryAction.schema = {
    type: 'object',
    properties: {
        label: {type: 'string'},
        iconId: {type: 'string'},
        action: {type: 'string'},
        parentUid: {type: ['object', 'null']}
    },
    required: ['label', 'iconId', 'action']
}

export class AssociateActivityWithOpeningTicketPurposeAction {
}

AssociateActivityWithOpeningTicketPurposeAction.schema = {
    type: 'object',
    properties: {
        activityUid: {type: 'object'},
    },
    required: ['activityUid']
}


// WEBPACK FOOTER //
// ./lib/reference/models.js